import { replaceDoubleSpaceToSingle } from 'utils';
import { maskPhoneNum, maskSsn } from '../../../../utils';

const updateState = (occupants, updatedOccupant, internalStateSetter, outlet) => {
  internalStateSetter({ occupant: updatedOccupant });

  const updatedOccupants = occupants.map((item) => {
    if (item.id === updatedOccupant.id) return updatedOccupant;
    return item;
  });

  outlet({ occupants: updatedOccupants });
};

export default {
  'Occupant.Wrapper.Name': ({ occupants, occupant, value }, outlet, internalStateSetter) => {
    const updatedOccupant = { ...occupant, name: replaceDoubleSpaceToSingle(value), nameError: '', hasError: false };
    updateState(occupants, updatedOccupant, internalStateSetter, outlet);
  },

  'Occupant.Wrapper.DOB': ({ occupants, occupant, selectedDate }, outlet, internalStateSetter) => {
    const updatedOccupant = { ...occupant, dob: selectedDate, dobError: '', hasError: false };
    updateState(occupants, updatedOccupant, internalStateSetter, outlet);
  },
  'Occupant.Wrapper.Email': ({ occupants, occupant, value }, outlet, internalStateSetter) => {
    const updatedOccupant = { ...occupant, email: value, emailError: '', hasError: false };
    updateState(occupants, updatedOccupant, internalStateSetter, outlet);
  },
  'Occupant.Wrapper.SSN': ({ occupants, occupant, value }, outlet, internalStateSetter) => {
    const maskedSsn = maskSsn(value);
    const updatedOccupant = { ...occupant, ssn: maskedSsn, ssnError: '', hasError: false };
    updateState(occupants, updatedOccupant, internalStateSetter, outlet);
  },
  'Occupant.Wrapper.HomePhone': ({ occupants, occupant, value }, outlet, internalStateSetter) => {
    const maskedNum = maskPhoneNum(value);
    const updatedOccupant = { ...occupant, homePhone: maskedNum, homePhoneError: '', workPhoneError: '', cellPhoneError: '', hasError: false };
    updateState(occupants, updatedOccupant, internalStateSetter, outlet);
  },
  'Occupant.Wrapper.WorkPhone': ({ occupants, occupant, value }, outlet, internalStateSetter) => {
    const maskedNum = maskPhoneNum(value);
    const updatedOccupant = { ...occupant, workPhone: maskedNum, homePhoneError: '', workPhoneError: '', cellPhoneError: '', hasError: false };
    updateState(occupants, updatedOccupant, internalStateSetter, outlet);
  },
  'Occupant.Wrapper.CellPhone': ({ occupants, occupant, value }, outlet, internalStateSetter) => {
    const maskedNum = maskPhoneNum(value);
    const updatedOccupant = { ...occupant, cellPhone: maskedNum, homePhoneError: '', workPhoneError: '', cellPhoneError: '', hasError: false };
    updateState(occupants, updatedOccupant, internalStateSetter, outlet);
  },
  'Occupant.Wrapper.StatusDropdown': ({ occupants, occupant, selectedOptionId }, outlet, internalStateSetter) => {
    const updatedOccupant = { ...occupant, status: selectedOptionId, dobError: '' };
    updateState(occupants, updatedOccupant, internalStateSetter, outlet);
  },
  'Occupant.Wrapper.DeleteButton': ({ resourceList: occupants, id }, outlet) => {
    outlet({ occupants, removedOccupantID: id });
  }

};
